import { Schema as ProductsSchema } from "@comparaonline/products-schema";
import { Schema as QuoterSchema } from "@comparaonline/quoter-schema";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import { getMainAttribute } from "../../../models/product/getMainAttribute";

const buildMainAttribute = (accurateText: string) => (
  product: QuoterSchema.Product | ProductsSchema.ProductListProduct
) => {
  const isOffer = Boolean(product.mainAttribute);
  const mainAttribute = getMainAttribute(product);
  return mainAttribute
    ? {
        ...mainAttribute,
        accurateText: mainAttribute.isAccurate && !isOffer ? accurateText : undefined
      }
    : undefined;
};

export const useMainAttribute = () => {
  const formatMessage = useFormatMessage();
  const accurateText = formatMessage("product.valueAccuracy");
  return buildMainAttribute(accurateText);
};
